module.exports = __webpack_public_path__ + "static/media/entregachips.dd6391d6.webp";